"use client";

import { useEffect } from "react";
import { useCustomer } from "@/contexts/customer-context";
import { useLocationStore, useRegionStore } from "@/store/index";
import { syncLocationFromCustomer } from "@/lib/util/sync-location";

/**
 * Fallback sync: if a user is already logged in but localStorage has no location
 * (e.g. cleared storage, incognito), sync from their customer metadata.
 * After sync, localStorage is the source of truth.
 */
export function LocationSync() {
  const { customer } = useCustomer();
  const locationStore = useLocationStore();
  const regionStore = useRegionStore();
  const hasSelectedLocation = locationStore.hasSelectedLocation;

  useEffect(() => {
    if (!customer || hasSelectedLocation) return;

    syncLocationFromCustomer(customer, {
      setRegion: regionStore.setRegion,
      setCountryCode: regionStore.setCountryCode,
      setHasSelectedRegion: regionStore.setHasSelectedRegion,
      setProvince: locationStore.setProvince,
      setMunicipality: locationStore.setMunicipality,
      setHasSelectedLocation: locationStore.setHasSelectedLocation,
    });
  }, [
    customer,
    hasSelectedLocation,
    locationStore.setProvince,
    locationStore.setMunicipality,
    locationStore.setHasSelectedLocation,
    regionStore.setRegion,
    regionStore.setCountryCode,
    regionStore.setHasSelectedRegion,
  ]);

  return null;
}
